import React from 'react';

const Header: React.FC = () => {
  return (
    <header className="text-center py-12 px-4">
      <div className="mb-3">
        <h1 className="text-5xl md:text-6xl font-black tracking-tight ig-gradient-text inline-block">
          Purgr
        </h1>
      </div>
      <p className="text-white/70 text-lg md:text-xl font-light max-w-xl mx-auto mb-6">
        Find out who's not following you back — in seconds.
      </p>
      <div className="inline-flex items-center gap-2 bg-white/5 border border-white/10 rounded-full px-4 py-2 text-sm text-white/60">
        <span className="text-green-400">●</span>
        100% private — your files never leave your device
      </div>
    </header>
  );
};

export default Header;
